import React from "react";
import PropTypes from "prop-types";

const ExitConsultationButton = ({
  label = "Exit consultation",
  onClick,
  topOffset,
  className = "",
  disabled = false,
}) => {
  return (
    <button
      type="button"
      className={`exit-consultation-btn ${className}`.trim()}
      style={topOffset ? { top: topOffset } : undefined}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
    >
      <span className="exit-consultation-btn__label-wrap">
        <span className="exit-consultation-btn__label">{label}</span>
      </span>
      <span className="exit-consultation-btn__icon" aria-hidden="true">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99908 9.05974L3.52941 13.5294L2.46875 12.4688L6.93842 7.99908L2.46875 3.52941L3.52941 2.46875L7.99908 6.93842L12.4688 2.46875L13.5294 3.52941L9.05974 7.99908L13.5294 12.4688L12.4688 13.5294L7.99908 9.05974Z"
            fill="white"
          />
        </svg>
      </span>
    </button>
  );
};

ExitConsultationButton.propTypes = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  topOffset: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ExitConsultationButton;
